module.exports = __webpack_public_path__ + "static/media/navigation-api.118c7f0b.yml";